import { memo } from "react"
import styled from "styled-components";
import { message } from "antd";

import { FaEye, FaCode, FaCopy } from "react-icons/fa6";
import { IoChevronDown } from "react-icons/io5";


const ShareProjectLink = () => {
  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    message.success('Đã sao chép liên kết bản đồ vào bộ nhớ tạm!');
  };

  return (
    <UI_Wrapper>
      <UI_Access>
        <UI_Left>
          <FaEye />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, }}>
            <div style={{ fontSize: 12 }}>Truy cập công khai: Chỉ xem</div>
            <div style={{ fontSize: 12, color: '#aaa' }}>Bất kỳ ai có link này đều xem được</div>
          </div>
        </UI_Left>
        <UI_Right>
          <IoChevronDown />
        </UI_Right>
      </UI_Access>

      <UI_Footer>
        <UI_FooterItem>
          <FaCode />
          <div>Nhúng</div>
        </UI_FooterItem>
        <UI_FooterItem onClick={handleCopyLink}>
          <FaCopy />
          <div>Copy link</div>
        </UI_FooterItem>
      </UI_Footer>
    </UI_Wrapper>
  )
}

export default memo(ShareProjectLink);

const UI_Wrapper = styled.div`

`

const UI_Access = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px;

  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  &:hover {
    background - color: #f0f0f0;
  }
`

const UI_Left = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`

const UI_Right = styled.div`

`



const UI_Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 8px;
`

const UI_FooterItem = styled.div`
  display: flex;
  gap: 8px;
  color: #333;
  font-size: 12px;
  cursor: pointer;
`